module.exports = __webpack_public_path__ + "static/piscine_icon-48aee19cfa97636d6dec08d06df7d0f8.jpg";